import { useSelector } from 'react-redux';
import { clsx } from 'clsx';
import {
  Box,
  CircularProgress,
  IconButton,
  Step,
  StepLabel,
  Stepper,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';

import { useGetNutritionistTestOptions } from 'features/nutritionists/services/get-nutritionist-test-options.service';

import { nutritionistTestCurrentStepSelector } from 'features/nutritionists/selectors/nutritionist-test.selector';

import { NutritionistSearchTestStep1Form } from './components/step-1-form/nutritionist-search-test-step-1-form.component';
import { NutritionistSearchTestStep2Form } from './components/step-2-form/nutritionist-search-test-step-2-form.component';
import { NutritionistSearchTestStep3Form } from './components/step-3-form/nutritionist-search-test-step-3-form.component';
import { NutritionistSearchTestStep4Form } from './components/step-4-form/nutritionist-search-test-step-4-form.component';
import { NutritionistSearchTestStep5Form } from './components/step-5-form/nutritionist-search-test-step-5-form.component';

import { useStyles } from './nutritionist-search-test.styles';

const MAX_STEPS = 5;

export const NutritionistSearchTest = () => {
  const step = useSelector(nutritionistTestCurrentStepSelector);

  const getNutritionistTestOptionsService = useGetNutritionistTestOptions();

  const classes = useStyles();

  const onCloseTestHandler = () => {
    console.log('Should close test');
  };

  if (getNutritionistTestOptionsService.isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box className={clsx(classes.stack, classes.relative)}>
      <Tooltip title="Cerrar test" className={classes.closeButton}>
        <IconButton size="small" onClick={onCloseTestHandler}>
          <Close fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <Typography variant="h6" className={classes.mainTitle}>
        Test para encontrar a tu nutriólogo ideal
      </Typography>
      <Stepper activeStep={step} className={classes.stepper}>
        {Array.from(Array(MAX_STEPS).keys()).map(index => (
          <Step key={`Paso ${index + 1}`}>
            <StepLabel>Paso {index + 1}</StepLabel>
          </Step>
        ))}
      </Stepper>

      <Box>
        {step === 0 && <NutritionistSearchTestStep1Form />}
        {step === 1 && <NutritionistSearchTestStep2Form />}
        {step === 2 && <NutritionistSearchTestStep3Form />}
        {step === 3 && <NutritionistSearchTestStep4Form />}
        {step === 4 && <NutritionistSearchTestStep5Form />}
      </Box>
    </Box>
  );
};
